import { Login } from "react-admin";
import { BrandLogo } from "../ui/BrandLogo";

export const AdminLogin = () => (
  <Login avatarIcon={<BrandLogo size={56} />} />
);
